import { ChangeDetectionStrategy, Component, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NavController,  IonNav } from '@ionic/angular';
import { Events } from '@omni/events';
import { NavigationService, ChildNavNames, PageName } from '../../../services/navigation/navigation.service';
import { UIService } from '../../../services/ui/ui.service';
import { DeviceService } from '../../../services/device/device.service';
import { FooterService } from '../../../services/footer/footer.service';
import { AgendaFooterService } from '@omni/services/footer/agenda-footer.service';
import { KOLStatusService } from '@omni/services/kol-status/kol-status-service';

/**
 * Generated class for the KOLStatusPageComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'kol-status-page[base-page]',
  templateUrl: 'kol-status-page.html',
  styleUrls:['kol-status-page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KOLStatusPageComponent {
  private readonly _quickCreateDestroy$ = new Subject<void>();

  @ViewChild('kolstatuspagerightpane', {static:true}) public navCtrl: IonNav;

  constructor(
    private readonly _quickCreateCd: ChangeDetectorRef,
    public navService: NavigationService,
    public uiService: UIService,
    public device: DeviceService,
    private footerService: FooterService,
    private events: Events,
    public agendaFooterService: AgendaFooterService,
    private readonly kolStatusService: KOLStatusService,
  ) {
  }

  ngOnInit() {
    // The template reads isActiveChildNavRightPaneViewDisplayed directly, but OnPush means
    // a pushed page (a quick-created meeting) flips the flag with nothing to repaint on.
    this.navService.childNavRightPaneView$.pipe(
      takeUntil(this._quickCreateDestroy$))
      .subscribe(() => {
        this._quickCreateCd.detectChanges();
      });
    this.navService.initRightPaneChildNav(this.navCtrl, ChildNavNames.KOLStatusPageNavigation, PageName.KOLStatusPageComponent, false, {deviceString: this.device.deviceFlags.ios ? 'ios' : 'other'});
    this.footerService.initButtons('');
  }

  ionViewDidEnter() {
  }

  public isSplitView(): boolean {
    return (window.innerWidth > 500);
  }

  ngOnDestroy(){
    this._quickCreateDestroy$.next();
    this._quickCreateDestroy$.complete();
    // this.agendaFooterService.initButtons(this.agendaFooterService.footerViewAtHome);
    // this.agendaFooterService.footerViewAtHome = null;
    this.kolStatusService.myKOLStatusRecords = [];
    this.kolStatusService.diseaseAreasList = [];
    this.navService.popChildNavCtrlFromStack(ChildNavNames.KOLStatusPageNavigation);
  }

}
